<div [@routerTransition] class="theme-custom">
<div > 
    <div class="m-subheader text-center" style="font-family: 'Source Sans Pro',sans-serif;">
        <div class="align-items-center">
            <div class="mr-auto">
                <h3 class="m-subheader__title">
                    Select Your Package, Get Started Instantly
                </h3>
            </div>
        </div>
    </div>
    <div id="cplp_pricing-table" class="container cplp_pricing-tables">
        <div id="main-filter" class="kt-pricing-2 d-flex align-items-center" style="justify-content: space-between;">
            <div class="drp-currnecy">
                <ng-select id="country" style="width: 220px;" name="country" [clearable]="false" [items]="Countries"
                    bindLabel="currency" bindValue="iso" [(ngModel)]="selectedCountry"
                    (change)="onddlCountryChange($event)" [searchable]="false">
                    <ng-template ng-label-tmp let-item="item">
                        <img style="position: absolute;margin-top: 0px;left: 15px;height: 20px !important;"
                            decoding="async" loading="lazy" width="35px" height="20px"
                            src="https://flagcdn.com/w40/{{item.iso.toLowerCase()}}.png"
                            alt="{{item.iso}} - Cable Pro Web Software" title="Cable Pro Web Software">
                        {{item.countryName}}
                        <span
                            style="font-weight: 600;font-size: 16px;color: #243CBB;position: absolute;right: 25px;">{{item.symbol}}</span>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-index="index">
                        <img style="position: absolute;margin-top: 3px;left: 15px;height: 20px !important;"
                            decoding="async" loading="lazy" width="35px" height="20px"
                            src="https://flagcdn.com/w40/{{item.iso.toLowerCase()}}.png"
                            alt="{{item.iso}} - Cable Pro Web Software" title="Cable Pro Web Software">
                        {{item.countryName}}
                        <span
                            style="font-size: 14px;color: #243CBB;position: absolute;right: 8px;">{{item.symbol}}</span>
                    </ng-template>
                </ng-select>
                <!-- <ng-select class="drp-standard-web" style="width: 220px;" *ngIf="isFromWebfacing || isFromHomePgae" [disabled]="standardSelectionDisabled" id="standard" name="standard" [clearable]="false"
                    [items]="cableSizes" bindLabel="text" bindValue="id" [(ngModel)]="drpCableSizing"
                    (change)="onStandardChange()" [searchable]="false">
                </ng-select> -->
            </div>
            <!-- <div class="drp-standard-mobile" *ngIf="isFromWebfacing || isFromHomePgae" style="width: 220px;">
                <ng-select [disabled]="standardSelectionDisabled" id="standard-mobile" name="standard-mobile" [clearable]="false"
                    [items]="cableSizes" bindLabel="text" bindValue="id" [(ngModel)]="drpCableSizing"
                    (change)="onStandardChange()" [searchable]="false">
                </ng-select>
            </div> -->
            <div class="cl-flex">
                <div
                    class="drp-currnecy cl-flex cl-w-fit cl-p-[6px] cl-rounded-[8px] title-small cl-shadow-depth1 cl-backdrop-blur-lg cl-bg-white">
                    <div class="cl-py-2 cl-px-4 cl-cursor-pointer cl-rounded-[4px]"
                        [ngClass]="{'cl-bg-black/5': !isMonthly,'cl-bg-white':isMonthly}"
                        (click)="isMonthly = !isMonthly">
                        Annual <span class="cl-text-g0-dark-green-500">(Save 45%)</span></div>
                    <div class="cl-py-2 cl-px-4 cl-cursor-pointer cl-rounded-[4px]"
                        [ngClass]="{'cl-bg-black/5': isMonthly,'cl-bg-white':!isMonthly}"
                        (click)="isMonthly = !isMonthly">
                        Monthly</div>
                </div>
            </div>
            <div class="PricingHeader_Content">
                <span>No. of users: </span>
                <input type="number" class="no-arrow" [(ngModel)]="noOfUsers" name="noOfUsers" min="1" max="1000"
                    (input)="CommonValidationFn($event)">
                <div class="PricingHeader_NumberBtns">
                    <button (click)="decrease()" [disabled]="noOfUsers <= 1">-</button>
                    <button (click)="increase()" [disabled]="noOfUsers >= 1000">+</button>
                </div>
            </div>
        </div>

        <div class="portlet light portlet-fit">
            <div class="portlet-body tab-content">
                <div class="row" id="pricing-row-annual" *ngIf="!isMonthly">
                    <div class="pricing1 container-fluid col-md-12">
                        <div class="overflow-scroll" #scrollContainer>
                            <div class="row flex-nowrap mt-4">
                                <!-- Column -->
                                <div class="col-lg-3 col-md-6 col-sm-8 col-12 mb-5"
                                    [ngClass]="{'free-plan':plan.heading.toLowerCase() == 'free'}"
                                    *ngFor="let plan of annualPlanOutput">
                                    <div class="cl-flex cl-flex-col cl-gap-[15px] cl-p-6 cl-rounded-[8px] cl-bg-white"
                                        [ngClass]="{'most-popular': plan.heading.toLowerCase()== 'premium'}"
                                        style="border-width: 1px;border-color: rgb(224, 224, 224);box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.1) 0px 2px 4px -2px;">

                                        <div class="cl-flex cl-flex-col cl-gap-3">
                                            <div class="cl-flex cl-items-center">
                                                <svg *ngIf="plan.heading.toLowerCase()== 'premium'" fill="none"
                                                    viewBox="0 0 22 22" class="cl-mr-2" width="22" height="22"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M18.5625 4.125C17.4231 4.125 16.5 5.04883 16.5 6.1875C16.5 6.47625 16.5605 6.75005 16.6672 6.99995L13.75 8.25L11.3095 3.85773C11.9419 3.5047 12.375 2.83731 12.375 2.0625C12.375 0.923828 11.4519 0 10.3125 0C9.17314 0 8.25 0.923828 8.25 2.0625C8.25 2.83731 8.68313 3.5047 9.31545 3.85773L6.875 8.25L3.95777 6.99995C4.0645 6.75005 4.125 6.47625 4.125 6.1875C4.125 5.04883 3.20186 4.125 2.0625 4.125C0.923141 4.125 0 5.04883 0 6.1875C0 7.32617 0.923141 8.25 2.0625 8.25C2.22234 8.25 2.37566 8.22714 2.5257 8.19363L4.125 15.125V16.5C4.125 17.26 4.74066 17.875 5.5 17.875H15.125C15.8843 17.875 16.5 17.26 16.5 16.5V15.125L18.1 8.19363C18.249 8.22852 18.4027 8.25 18.5625 8.25C19.7019 8.25 20.625 7.32617 20.625 6.1875C20.625 5.04883 19.7019 4.125 18.5625 4.125ZM10.3125 1.375C10.6918 1.375 11 1.68386 11 2.0625C11 2.44114 10.6918 2.75 10.3125 2.75C9.93317 2.75 9.625 2.44114 9.625 2.0625C9.625 1.68386 9.93317 1.375 10.3125 1.375ZM1.375 6.1875C1.375 5.80886 1.68317 5.5 2.0625 5.5C2.44183 5.5 2.75 5.80886 2.75 6.1875C2.75 6.56614 2.44183 6.875 2.0625 6.875C1.68317 6.875 1.375 6.56614 1.375 6.1875ZM15.125 16.5H5.5V15.125H15.125V16.5ZM15.4057 13.75H5.21933L4.01156 8.51864L6.33325 9.51362C6.50908 9.58873 6.69298 9.625 6.87431 9.625C7.36037 9.625 7.8277 9.36719 8.07675 8.91739L10.3125 4.89448L12.5483 8.91739C12.7973 9.36719 13.2646 9.625 13.7507 9.625C13.932 9.625 14.1159 9.58873 14.2917 9.51362L16.6134 8.51864L15.4057 13.75ZM18.5625 6.875C18.1832 6.875 17.875 6.56614 17.875 6.1875C17.875 5.80886 18.1832 5.5 18.5625 5.5C18.9418 5.5 19.25 5.80886 19.25 6.1875C19.25 6.56614 18.9418 6.875 18.5625 6.875Z"
                                                        fill="#2c77e8"></path>
                                                </svg>
                                                <div class="title-medium text-uppercase cl-text-g0-primary">
                                                    {{plan.heading}}
                                                </div>
                                                <div *ngIf="plan.heading.toLowerCase()== 'premium'"
                                                    class="cl-py-1 cl-px-2 cl-rounded-[12px] label-extra-small cl-ml-3 cl-text-white cl-bg-g0-dark-green-500 text-uppercase">
                                                    Most Popular</div>
                                            </div>
                                            <div class="caption cl-text-[#777]">
                                                {{plan.subHeading}}
                                            </div>
                                        </div>
                                        <div class="cl-flex cl-flex-col cl-gap-2">
                                            <div class="cl-text-g0-primary">
                                                <span *ngIf="!isUpdating; else loadingTemplate"
                                                    class="title-large">{{selectedCountryObj?.symbol}}{{getCurrencyForPrice(plan.calculatedPrice)}}</span>
                                                <ng-template #loadingTemplate>
                                                    <span class="title-large flicker">•••</span>
                                                </ng-template>
                                                <span class="body-small cl-ml-2">/ year</span>
                                            </div>

                                            <div class="label-small" style="min-height: 40px;"
                                                [innerHtml]="plan.discountText"></div>
                                            <div class="label-small"><span
                                                    *ngIf="selectedCountry == 'AU' && plan.heading.toLowerCase() != 'free'">GST
                                                    included</span></div>
                                        </div>
                                        <div
                                            class="cl-w-full cl-py-4 cl-text-center body-small cl-text-g0-primary cl-border-y-[#D9D9D9] cl-border-y-[1px]">
                                            {{plan.description}}</div>
                                        <div class="cl-flex cl-flex-col cl-gap-[13px]" style="min-height: 408px;">
                                            <div class="cl-flex cl-gap-3 cl-items-center" *ngIf="plan.featureText1"
                                                [innerHtml]="plan.featureText1">
                                            </div>
                                            <div class="cl-flex cl-gap-3 cl-items-center" *ngIf="plan.featureText2"
                                                [innerHtml]="plan.featureText2">
                                            </div>
                                            <div class="cl-flex cl-gap-3 cl-items-center" *ngIf="plan.featureText3"
                                                [innerHtml]="plan.featureText3">
                                            </div>
                                            <div class="cl-flex cl-gap-3 cl-items-center" *ngIf="plan.featureText4"
                                                [innerHtml]="plan.featureText4">
                                            </div>
                                            <div class="cl-flex cl-gap-3 cl-items-center" *ngIf="plan.featureText5"
                                                [innerHtml]="plan.featureText5">
                                            </div>
                                            <div class="cl-flex cl-gap-3 cl-items-center" *ngIf="plan.featureText6"
                                                [innerHtml]="plan.featureText6">
                                            </div>
                                            <div class="cl-flex cl-gap-3 cl-items-center" *ngIf="plan.featureText7"
                                                [innerHtml]="plan.featureText7">
                                            </div>
                                            <div class="cl-flex cl-gap-3 cl-items-center" *ngIf="plan.featureText8"
                                                [innerHtml]="plan.featureText8">
                                            </div>
                                            <div class="cl-flex cl-gap-3 cl-items-center" *ngIf="plan.featureText9"
                                                [innerHtml]="plan.featureText9">
                                            </div>
                                            <div class="cl-flex cl-gap-3 cl-items-center" *ngIf="plan.featureText10"
                                                [innerHtml]="plan.featureText10">
                                            </div>
                                            <div class="cl-flex cl-gap-3 cl-items-center" *ngIf="plan.featureText11"
                                                [innerHtml]="plan.featureText11">
                                            </div>
                                        </div>
                                        <div class="cl-flex-1"></div>
                                        <ng-container *ngTemplateOutlet="planCtaButtons; context: { plan: plan, compact: false, accountLabel: 'Create Free Account' }"></ng-container>
                                        <p class="text-center" class="text-center" style="margin: 15px 0px 10px 0px;"
                                            [ngClass]="{'hidden': plan.heading.toLowerCase() == 'free'}"
                                            *ngIf="isFromHomePgae">(Purchase in the app)
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" id="pricing-row-monthly" *ngIf="isMonthly">
                    <div class="pricing1 container-fluid col-md-12">
                        <div class="overflow-scroll" #scrollContainer>
                            <div class="row flex-nowrap mt-4">
                                <!-- Column -->
                                <div class="col-lg-3 col-md-6 col-sm-8 col-12 mb-5"
                                    [ngClass]="{'free-plan':plan.heading.toLowerCase() == 'free'}"
                                    *ngFor="let plan of monthlyPlanOutput">
                                    <div class="cl-flex cl-flex-col cl-gap-[15px] cl-p-6 cl-rounded-[8px] cl-bg-white"
                                        [ngClass]="{'most-popular': plan.heading.toLowerCase()== 'premium'}"
                                        style="border-width: 1px;border-color: rgb(224, 224, 224);box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.1) 0px 2px 4px -2px;">

                                        <div class="cl-flex cl-flex-col cl-gap-3">
                                            <div class="cl-flex cl-items-center">
                                                <svg *ngIf="plan.heading.toLowerCase()== 'premium'" fill="none"
                                                    viewBox="0 0 22 22" class="cl-mr-2" width="22" height="22"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M18.5625 4.125C17.4231 4.125 16.5 5.04883 16.5 6.1875C16.5 6.47625 16.5605 6.75005 16.6672 6.99995L13.75 8.25L11.3095 3.85773C11.9419 3.5047 12.375 2.83731 12.375 2.0625C12.375 0.923828 11.4519 0 10.3125 0C9.17314 0 8.25 0.923828 8.25 2.0625C8.25 2.83731 8.68313 3.5047 9.31545 3.85773L6.875 8.25L3.95777 6.99995C4.0645 6.75005 4.125 6.47625 4.125 6.1875C4.125 5.04883 3.20186 4.125 2.0625 4.125C0.923141 4.125 0 5.04883 0 6.1875C0 7.32617 0.923141 8.25 2.0625 8.25C2.22234 8.25 2.37566 8.22714 2.5257 8.19363L4.125 15.125V16.5C4.125 17.26 4.74066 17.875 5.5 17.875H15.125C15.8843 17.875 16.5 17.26 16.5 16.5V15.125L18.1 8.19363C18.249 8.22852 18.4027 8.25 18.5625 8.25C19.7019 8.25 20.625 7.32617 20.625 6.1875C20.625 5.04883 19.7019 4.125 18.5625 4.125ZM10.3125 1.375C10.6918 1.375 11 1.68386 11 2.0625C11 2.44114 10.6918 2.75 10.3125 2.75C9.93317 2.75 9.625 2.44114 9.625 2.0625C9.625 1.68386 9.93317 1.375 10.3125 1.375ZM1.375 6.1875C1.375 5.80886 1.68317 5.5 2.0625 5.5C2.44183 5.5 2.75 5.80886 2.75 6.1875C2.75 6.56614 2.44183 6.875 2.0625 6.875C1.68317 6.875 1.375 6.56614 1.375 6.1875ZM15.125 16.5H5.5V15.125H15.125V16.5ZM15.4057 13.75H5.21933L4.01156 8.51864L6.33325 9.51362C6.50908 9.58873 6.69298 9.625 6.87431 9.625C7.36037 9.625 7.8277 9.36719 8.07675 8.91739L10.3125 4.89448L12.5483 8.91739C12.7973 9.36719 13.2646 9.625 13.7507 9.625C13.932 9.625 14.1159 9.58873 14.2917 9.51362L16.6134 8.51864L15.4057 13.75ZM18.5625 6.875C18.1832 6.875 17.875 6.56614 17.875 6.1875C17.875 5.80886 18.1832 5.5 18.5625 5.5C18.9418 5.5 19.25 5.80886 19.25 6.1875C19.25 6.56614 18.9418 6.875 18.5625 6.875Z"
                                                        fill="#2c77e8"></path>
                                                </svg>
                                                <div class="title-medium text-uppercase cl-text-g0-primary">
                                                    {{plan.heading}}
                                                </div>
                                                <div *ngIf="plan.heading.toLowerCase()== 'premium'"
                                                    class="cl-py-1 cl-px-2 cl-rounded-[12px] label-extra-small cl-ml-3 cl-text-white cl-bg-g0-dark-green-500 text-uppercase">
                                                    Most Popular</div>
                                            </div>
                                            <div class="caption cl-text-[#777]">
                                                {{plan.subHeading}}
                                            </div>
                                        </div>
                                        <div class="cl-flex cl-flex-col cl-gap-2">
                                            <div class="cl-text-g0-primary"><span
                                                    *ngIf="!isUpdating; else loadingTemplate"
                                                    class="title-large">{{selectedCountryObj?.symbol}}{{getCurrencyForPrice(plan.calculatedPrice)}}</span>
                                                <ng-template #loadingTemplate>
                                                    <span class="title-large flicker">•••</span>
                                                </ng-template>
                                                <span class="body-small cl-ml-2">/ month</span>
                                            </div>
                                            <div class="label-small" style="min-height: 40px;"
                                                [innerHtml]="plan.discountText"></div>
                                            <div class="label-small"><span
                                                    *ngIf="selectedCountry == 'AU' && plan.heading.toLowerCase() != 'free'">GST
                                                    included</span></div>
                                        </div>
                                        <div
                                            class="cl-w-full cl-py-4 cl-text-center body-small cl-text-g0-primary cl-border-y-[#D9D9D9] cl-border-y-[1px]">
                                            {{plan.description}}</div>
                                        <div class="cl-flex cl-flex-col cl-gap-[13px]" style="min-height: 408px;">
                                            <div class="cl-flex cl-gap-3 cl-items-center" *ngIf="plan.featureText1"
                                                [innerHtml]="plan.featureText1">
                                            </div>
                                            <div class="cl-flex cl-gap-3 cl-items-center" *ngIf="plan.featureText2"
                                                [innerHtml]="plan.featureText2">
                                            </div>
                                            <div class="cl-flex cl-gap-3 cl-items-center" *ngIf="plan.featureText3"
                                                [innerHtml]="plan.featureText3">
                                            </div>
                                            <div class="cl-flex cl-gap-3 cl-items-center" *ngIf="plan.featureText4"
                                                [innerHtml]="plan.featureText4">
                                            </div>
                                            <div class="cl-flex cl-gap-3 cl-items-center" *ngIf="plan.featureText5"
                                                [innerHtml]="plan.featureText5">
                                            </div>
                                            <div class="cl-flex cl-gap-3 cl-items-center" *ngIf="plan.featureText6"
                                                [innerHtml]="plan.featureText6">
                                            </div>
                                            <div class="cl-flex cl-gap-3 cl-items-center" *ngIf="plan.featureText7"
                                                [innerHtml]="plan.featureText7">
                                            </div>
                                            <div class="cl-flex cl-gap-3 cl-items-center" *ngIf="plan.featureText8"
                                                [innerHtml]="plan.featureText8">
                                            </div>
                                            <div class="cl-flex cl-gap-3 cl-items-center" *ngIf="plan.featureText9"
                                                [innerHtml]="plan.featureText9">
                                            </div>
                                            <div class="cl-flex cl-gap-3 cl-items-center" *ngIf="plan.featureText10"
                                                [innerHtml]="plan.featureText10">
                                            </div>
                                            <div class="cl-flex cl-gap-3 cl-items-center" *ngIf="plan.featureText11"
                                                [innerHtml]="plan.featureText11">
                                            </div>
                                        </div>
                                        <div class="cl-flex-1"></div>
                                        <ng-container *ngTemplateOutlet="planCtaButtons; context: { plan: plan, compact: false, accountLabel: 'Create Account' }"></ng-container>
                                        <p class="text-center" style="margin: 15px 0px 10px 0px;"
                                            [ngClass]="{'hidden': plan.heading.toLowerCase() == 'free'}"
                                            *ngIf="isFromHomePgae">
                                            (Purchase in the app)
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div id="successDiv" *ngIf="successFlag">
                <div class="alert alert-success fade show" role="alert">
                    <div class="alert-icon"><i class="flaticon-warning"></i></div>
                    <div class="alert-text"> {{subscribePlanResult}} </div>
                    <div class="alert-close">
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true"><i class="la la-close"></i></span>
                        </button>
                    </div>
                </div>
            </div>
            <div id="errorDiv" *ngIf="errorFlag">
                <div class="alert alert-danger fade show" role="alert">
                    <div class="alert-icon"><i class="flaticon-warning"></i></div>
                    <div class="alert-text"> {{subscribePlanResult}} </div>
                    <div class="alert-close">
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true"><i class="la la-close"></i></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div #compareSection class="md:block mt-5 mb-5 m--visible-desktop-inline-block"
            *ngIf="annualPlanOutput && annualPlanOutput.length > 0 && comparePlans && comparePlans.length > 0">
            <div #firstColumn class="col-md-12 cl-flex md:cl-gap-2 p-0">
                <div class="col-md-4 cl-flex cl-flex-col cl-pt-6 cl-px-2 lg:cl-pt-5 cl-rounded-t-[16px]"
                    style="flex-direction: column;justify-content: space-between;flex:2">
                    <div class="title-large text-center">Compare Plans</div>
                    <div class="title-medium cl-pb-3 cl-pt-10 cl-border-b-[1px] cl-border-b-gray-100 md:cl-w-[192px] lg:cl-w-[242px]"
                        style="padding-bottom: 37px;padding-left: 10px;">GENERAL FEATURES</div>
                </div>
                <ng-container *ngIf="!isMonthly">
                    <div *ngFor="let plan of annualPlanOutput"
                        class="col-md-2 bg-white cl-border-g0-gray-100 cl-border-b-0 cl-rounded-t-[16px] lg:cl-pt-5"
                        [ngClass]="{'most-popular': plan.heading.toLowerCase()== 'premium'}"
                        style="display: flex;flex-direction: column;gap: 5px;flex:1;">
                        <div class="cl-flex cl-items-center">
                            <svg *ngIf="plan.heading.toLowerCase()== 'premium'" fill="none" viewBox="0 0 22 22"
                                class="cl-mr-2" width="22" height="22" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M18.5625 4.125C17.4231 4.125 16.5 5.04883 16.5 6.1875C16.5 6.47625 16.5605 6.75005 16.6672 6.99995L13.75 8.25L11.3095 3.85773C11.9419 3.5047 12.375 2.83731 12.375 2.0625C12.375 0.923828 11.4519 0 10.3125 0C9.17314 0 8.25 0.923828 8.25 2.0625C8.25 2.83731 8.68313 3.5047 9.31545 3.85773L6.875 8.25L3.95777 6.99995C4.0645 6.75005 4.125 6.47625 4.125 6.1875C4.125 5.04883 3.20186 4.125 2.0625 4.125C0.923141 4.125 0 5.04883 0 6.1875C0 7.32617 0.923141 8.25 2.0625 8.25C2.22234 8.25 2.37566 8.22714 2.5257 8.19363L4.125 15.125V16.5C4.125 17.26 4.74066 17.875 5.5 17.875H15.125C15.8843 17.875 16.5 17.26 16.5 16.5V15.125L18.1 8.19363C18.249 8.22852 18.4027 8.25 18.5625 8.25C19.7019 8.25 20.625 7.32617 20.625 6.1875C20.625 5.04883 19.7019 4.125 18.5625 4.125ZM10.3125 1.375C10.6918 1.375 11 1.68386 11 2.0625C11 2.44114 10.6918 2.75 10.3125 2.75C9.93317 2.75 9.625 2.44114 9.625 2.0625C9.625 1.68386 9.93317 1.375 10.3125 1.375ZM1.375 6.1875C1.375 5.80886 1.68317 5.5 2.0625 5.5C2.44183 5.5 2.75 5.80886 2.75 6.1875C2.75 6.56614 2.44183 6.875 2.0625 6.875C1.68317 6.875 1.375 6.56614 1.375 6.1875ZM15.125 16.5H5.5V15.125H15.125V16.5ZM15.4057 13.75H5.21933L4.01156 8.51864L6.33325 9.51362C6.50908 9.58873 6.69298 9.625 6.87431 9.625C7.36037 9.625 7.8277 9.36719 8.07675 8.91739L10.3125 4.89448L12.5483 8.91739C12.7973 9.36719 13.2646 9.625 13.7507 9.625C13.932 9.625 14.1159 9.58873 14.2917 9.51362L16.6134 8.51864L15.4057 13.75ZM18.5625 6.875C18.1832 6.875 17.875 6.56614 17.875 6.1875C17.875 5.80886 18.1832 5.5 18.5625 5.5C18.9418 5.5 19.25 5.80886 19.25 6.1875C19.25 6.56614 18.9418 6.875 18.5625 6.875Z"
                                    fill="#2c77e8"></path>
                            </svg>
                            <div class="title-medium text-uppercase cl-text-g0-primary">
                                {{plan.heading}}
                            </div>
                        </div>
                        <div class="cl-text-[#777] caption cl-mb-6" style="min-height: 58.5px;">{{plan.subHeading}}
                        </div>
                        <ng-container *ngTemplateOutlet="planCtaButtons; context: { plan: plan, compact: isBetweenWidth, accountLabel: 'Create Account' }"></ng-container>
                        <hr class="cl-mt-6 mb-0" style="margin-left: -15px;margin-right: -15px;">
                    </div>
                </ng-container>
                <ng-container *ngIf="isMonthly">
                    <div *ngFor="let plan of monthlyPlanOutput"
                        class="col-md-2 bg-white cl-border-g0-gray-100 cl-border-b-0 cl-rounded-t-[16px] lg:cl-pt-5"
                        [ngClass]="{'most-popular': plan.heading.toLowerCase()== 'premium'}"
                        style="display: flex;flex-direction: column;gap: 5px;flex:1;">
                        <div class="cl-flex cl-items-center">
                            <svg *ngIf="plan.heading.toLowerCase()== 'premium'" fill="none" viewBox="0 0 22 22"
                                class="cl-mr-2" width="22" height="22" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M18.5625 4.125C17.4231 4.125 16.5 5.04883 16.5 6.1875C16.5 6.47625 16.5605 6.75005 16.6672 6.99995L13.75 8.25L11.3095 3.85773C11.9419 3.5047 12.375 2.83731 12.375 2.0625C12.375 0.923828 11.4519 0 10.3125 0C9.17314 0 8.25 0.923828 8.25 2.0625C8.25 2.83731 8.68313 3.5047 9.31545 3.85773L6.875 8.25L3.95777 6.99995C4.0645 6.75005 4.125 6.47625 4.125 6.1875C4.125 5.04883 3.20186 4.125 2.0625 4.125C0.923141 4.125 0 5.04883 0 6.1875C0 7.32617 0.923141 8.25 2.0625 8.25C2.22234 8.25 2.37566 8.22714 2.5257 8.19363L4.125 15.125V16.5C4.125 17.26 4.74066 17.875 5.5 17.875H15.125C15.8843 17.875 16.5 17.26 16.5 16.5V15.125L18.1 8.19363C18.249 8.22852 18.4027 8.25 18.5625 8.25C19.7019 8.25 20.625 7.32617 20.625 6.1875C20.625 5.04883 19.7019 4.125 18.5625 4.125ZM10.3125 1.375C10.6918 1.375 11 1.68386 11 2.0625C11 2.44114 10.6918 2.75 10.3125 2.75C9.93317 2.75 9.625 2.44114 9.625 2.0625C9.625 1.68386 9.93317 1.375 10.3125 1.375ZM1.375 6.1875C1.375 5.80886 1.68317 5.5 2.0625 5.5C2.44183 5.5 2.75 5.80886 2.75 6.1875C2.75 6.56614 2.44183 6.875 2.0625 6.875C1.68317 6.875 1.375 6.56614 1.375 6.1875ZM15.125 16.5H5.5V15.125H15.125V16.5ZM15.4057 13.75H5.21933L4.01156 8.51864L6.33325 9.51362C6.50908 9.58873 6.69298 9.625 6.87431 9.625C7.36037 9.625 7.8277 9.36719 8.07675 8.91739L10.3125 4.89448L12.5483 8.91739C12.7973 9.36719 13.2646 9.625 13.7507 9.625C13.932 9.625 14.1159 9.58873 14.2917 9.51362L16.6134 8.51864L15.4057 13.75ZM18.5625 6.875C18.1832 6.875 17.875 6.56614 17.875 6.1875C17.875 5.80886 18.1832 5.5 18.5625 5.5C18.9418 5.5 19.25 5.80886 19.25 6.1875C19.25 6.56614 18.9418 6.875 18.5625 6.875Z"
                                    fill="#2c77e8"></path>
                            </svg>
                            <div class="title-medium text-uppercase cl-text-g0-primary">
                                {{plan.heading}}
                            </div>
                        </div>
                        <div class="cl-text-[#777] caption cl-mb-6" style="min-height: 58.5px;">{{plan.subHeading}}
                        </div>
                        <ng-container *ngTemplateOutlet="planCtaButtons; context: { plan: plan, compact: isBetweenWidth, accountLabel: 'Create Account' }"></ng-container>
                        <hr class="cl-mt-6 mb-0" style="margin-left: -15px;margin-right: -15px;">
                    </div>
                </ng-container>
            </div>
            <div class="cl-flex cl-flex-col">
                <!-- <div class="col-md-12 cl-flex md:cl-gap-2 p-0">
                    <div class="col-md-4 cl-body-medium cl-content-center"
                        style="line-height: 20px; font-size: 14px;flex:2;">
                        Price (Australian standard)
                    </div>
                    <div class="col-md-2 bg-white cl-border-x-[1px] body-medium cl-text-center cl-text-g0-primary  cl-content-center cl-py-5"
                        style="padding-top:12px;padding-bottom: 12px;flex:1;font-size: 14px;">
                        $0
                    </div>
                    <div class="col-md-2 bg-white cl-border-x-[1px] body-medium cl-text-center cl-text-g0-primary  cl-content-center cl-py-5"
                        style="padding-top:12px;padding-bottom: 12px;flex:1;font-size: 14px;">
                        $99 per year
                        <br>
                        $15 per month
                        <br>
                        50% discount for additional users (teams)
                    </div>
                    <div class="col-md-2 bg-white cl-border-x-[1px] body-medium cl-text-center cl-text-g0-primary  cl-content-center cl-py-5 most-popular"
                        style="padding-top:12px;padding-bottom: 12px;flex:1;font-size: 14px;">
                        $290 per year
                        <br>
                        $45 per month
                        <br>
                        50% discount for additional users (teams)
                    </div>
                    <div class="col-md-2 bg-white cl-border-x-[1px] body-medium cl-text-center cl-text-g0-primary  cl-content-center cl-py-5"
                        style="padding-top:12px;padding-bottom: 12px;flex:1;font-size: 14px;">
                        $650 per year
                        <br>
                        $99 per month
                        <br>
                        50% discount for additional users (teams)
                    </div>
                </div>
                <div class="col-md-12 cl-flex md:cl-gap-2 p-0">
                    <div class="col-md-4 cl-body-medium cl-content-center"
                        style="line-height: 20px; font-size: 14px;flex:2;">
                        Price (British standard)
                    </div>
                    <div class="col-md-2 bg-white cl-border-x-[1px] body-medium cl-text-center cl-text-g0-primary  cl-content-center cl-py-5"
                        style="padding-top:12px;padding-bottom: 12px;flex:1;font-size: 14px;">
                        £0
                    </div>
                    <div class="col-md-2 bg-white cl-border-x-[1px] body-medium cl-text-center cl-text-g0-primary  cl-content-center cl-py-5"
                        style="padding-top:12px;padding-bottom: 12px;flex:1;font-size: 14px;">
                        £57 per year
                        <br>
                        £10 per month
                        <br>
                        50% discount for additional users (teams)
                    </div>
                    <div class="col-md-2 bg-white cl-border-x-[1px] body-medium cl-text-center cl-text-g0-primary  cl-content-center cl-py-5 most-popular"
                        style="padding-top:12px;padding-bottom: 12px;flex:1;font-size: 14px;">
                        £169 per year
                        <br>
                        £29 per month
                        <br>
                        50% discount for additional users (teams)
                    </div>
                    <div class="col-md-2 bg-white cl-border-x-[1px] body-medium cl-text-center cl-text-g0-primary  cl-content-center cl-py-5"
                        style="padding-top:12px;padding-bottom: 12px;flex:1;font-size: 14px;">
                        £369 per year
                        <br>
                        £49 per month
                        <br>
                        50% discount for additional users (teams)
                    </div>
                </div>
                <div class="col-md-12 cl-flex md:cl-gap-2 p-0">
                    <div class="col-md-4 cl-body-medium cl-content-center"
                        style="line-height: 20px; font-size: 14px;flex:2;">
                        Price (IEC standard)
                    </div>
                    <div class="col-md-2 bg-white cl-border-x-[1px] body-medium cl-text-center cl-text-g0-primary  cl-content-center cl-py-5"
                        style="padding-top:12px;padding-bottom: 12px;flex:1;font-size: 14px;">
                        €0
                    </div>
                    <div class="col-md-2 bg-white cl-border-x-[1px] body-medium cl-text-center cl-text-g0-primary  cl-content-center cl-py-5"
                        style="padding-top:12px;padding-bottom: 12px;flex:1;font-size: 14px;">
                        €68 per year
                        <br>
                        €12 per month
                        <br>
                        50% discount for additional users (teams)
                    </div>
                    <div class="col-md-2 bg-white cl-border-x-[1px] body-medium cl-text-center cl-text-g0-primary  cl-content-center cl-py-5 most-popular"
                        style="padding-top:12px;padding-bottom: 12px;flex:1;font-size: 14px;">
                        €199 per year
                        <br>
                        €35 per month
                        <br>
                        50% discount for additional users (teams)
                    </div>
                    <div class="col-md-2 bg-white cl-border-x-[1px] body-medium cl-text-center cl-text-g0-primary  cl-content-center cl-py-5"
                        style="padding-top:12px;padding-bottom: 12px;flex:1;font-size: 14px;">
                        €435 per year
                        <br>
                        €57 per month
                        <br>
                        50% discount for additional users (teams)
                    </div>
                </div> -->
                <!-- <div class="col-md-12 cl-flex md:cl-gap-2 p-0">
                    <div class="col-md-4 cl-body-medium cl-content-center" style="flex:2">
                        <div class="title-medium" style="padding-top: 30px;padding-bottom: 12px;">
                            GENERAL FEATURES</div>
                    </div>
                    <div style="flex:1"
                        class="col-md-2 bg-white cl-border-x-[1px] body-medium cl-text-center cl-text-g0-primary  cl-content-center cl-py-5">
                        <div class="cl-rounded-full cl-flex cl-items-center cl-justify-center"
                            style="width: 22px; height: 22px;">
                        </div>
                    </div>
                    <div style="flex:1"
                        class="col-md-2 bg-white cl-border-x-[1px] body-medium cl-text-center cl-text-g0-primary  cl-content-center cl-py-5">
                        <div class="cl-rounded-full cl-flex cl-items-center cl-justify-center"
                            style="width: 22px; height: 22px;">
                        </div>
                    </div>
                    <div style="flex:1"
                        class="col-md-2 bg-white cl-border-x-[1px] body-medium cl-text-center cl-text-g0-primary  cl-content-center cl-py-5 most-popular">
                        <div class="cl-rounded-full cl-flex cl-items-center cl-justify-center"
                            style="width: 22px; height: 22px;">
                        </div>
                    </div>
                    <div style="flex:1"
                        class="col-md-2 bg-white cl-border-x-[1px] body-medium cl-text-center cl-text-g0-primary  cl-content-center cl-py-5">
                        <div class="cl-rounded-full cl-flex cl-items-center cl-justify-center"
                            style="width: 22px; height: 22px;">
                        </div>
                    </div>
                </div> -->
                <div class="col-md-12 cl-flex md:cl-gap-2 p-0">
                    <div class="col-md-4 cl-body-medium cl-content-center"
                        style="line-height: 20px; font-size: 14px;flex:2;">
                        Stored calculations (total)
                    </div>
                    <div class="col-md-2 bg-white cl-border-x-[1px] body-medium cl-text-center cl-text-g0-primary  cl-content-center cl-py-5"
                        style="padding-top:12px;padding-bottom: 12px;flex:1;font-size: 14px;">
                        5 assorted
                    </div>
                    <div class="col-md-2 bg-white cl-border-x-[1px] body-medium cl-text-center cl-text-g0-primary  cl-content-center cl-py-5"
                        style="padding-top:12px;padding-bottom: 12px;flex:1;font-size: 14px;">
                        150 assorted
                    </div>
                    <div class="col-md-2 bg-white cl-border-x-[1px] body-medium cl-text-center cl-text-g0-primary  cl-content-center cl-py-5 most-popular"
                        style="padding-top:12px;padding-bottom: 12px;flex:1;font-size: 14px;">
                        500 assorted
                    </div>
                    <div class="col-md-2 bg-white cl-border-x-[1px] body-medium cl-text-center cl-text-g0-primary  cl-content-center cl-py-5"
                        style="padding-top:12px;padding-bottom: 12px;flex:1;font-size: 14px;">
                        10000 assorted
                    </div>
                </div>
                <div class="col-md-12 cl-flex md:cl-gap-2 p-0">
                    <div class="col-md-4 cl-body-medium cl-content-center"
                        style="line-height: 20px; font-size: 14px;flex:2;">
                        Reports generated per day
                    </div>
                    <div class="col-md-2 bg-white cl-border-x-[1px] body-medium cl-text-center cl-text-g0-primary  cl-content-center cl-py-5"
                        style="padding-top:12px;padding-bottom: 12px;flex:1;font-size: 14px;">
                        5 assorted - watermarked
                    </div>
                    <div class="col-md-2 bg-white cl-border-x-[1px] body-medium cl-text-center cl-text-g0-primary  cl-content-center cl-py-5"
                        style="padding-top:12px;padding-bottom: 12px;flex:1;font-size: 14px;">
                        50 assorted
                    </div>
                    <div class="col-md-2 bg-white cl-border-x-[1px] body-medium cl-text-center cl-text-g0-primary  cl-content-center cl-py-5 most-popular"
                        style="padding-top:12px;padding-bottom: 12px;flex:1;font-size: 14px;">
                        250 assorted
                    </div>
                    <div class="col-md-2 bg-white cl-border-x-[1px] body-medium cl-text-center cl-text-g0-primary  cl-content-center cl-py-5"
                        style="padding-top:12px;padding-bottom: 12px;flex:1;font-size: 14px;">
                        3000 assorted
                    </div>
                </div>
            </div>
            <div class="cl-flex cl-flex-col" *ngFor="let group of groupedComparePlans; let groupIndex = index">
                <div class="col-md-12 cl-flex md:cl-gap-2 p-0" *ngIf="getCalculationTypeName(group.calculationTypeId)">
                    <div class="col-md-4 cl-body-medium cl-content-center" style="flex:2">
                        <div class="title-medium" style="padding-top: 30px;padding-bottom: 12px;">
                            {{ getCalculationTypeName(group.calculationTypeId) }}</div>
                    </div>
                    <div style="flex:1"
                        class="col-md-2 bg-white cl-border-x-[1px] body-medium cl-text-center cl-text-g0-primary  cl-content-center cl-py-5">
                        <div class="cl-rounded-full cl-flex cl-items-center cl-justify-center"
                            style="width: 22px; height: 22px;">
                        </div>
                    </div>
                    <div style="flex:1"
                        class="col-md-2 bg-white cl-border-x-[1px] body-medium cl-text-center cl-text-g0-primary  cl-content-center cl-py-5">
                        <div class="cl-rounded-full cl-flex cl-items-center cl-justify-center"
                            style="width: 22px; height: 22px;">
                        </div>
                    </div>
                    <div style="flex:1"
                        class="col-md-2 bg-white cl-border-x-[1px] body-medium cl-text-center cl-text-g0-primary  cl-content-center cl-py-5 most-popular">
                        <div class="cl-rounded-full cl-flex cl-items-center cl-justify-center"
                            style="width: 22px; height: 22px;">
                        </div>
                    </div>
                    <div style="flex:1"
                        class="col-md-2 bg-white cl-border-x-[1px] body-medium cl-text-center cl-text-g0-primary  cl-content-center cl-py-5">
                        <div class="cl-rounded-full cl-flex cl-items-center cl-justify-center"
                            style="width: 22px; height: 22px;">
                        </div>
                    </div>
                </div>
                <div class="col-md-12 cl-flex md:cl-gap-2 p-0" *ngFor="let feature of group.features; let i = index">
                    <div class="col-md-4 cl-body-medium cl-content-center"
                        style="line-height: 20px; font-size: 14px;flex:2;">
                        {{feature.featureType}}</div>

                    <ng-container *ngIf="isNumericValue(feature.m_FREE); else checkmarkFree">
                        <!-- Numeric value → Line bar div -->
                        <div class="col-md-2 bg-white cl-border-x-[1px] body-medium cl-text-center cl-text-g0-primary cl-flex cl-content-center cl-py-5 cl-flex-col gap-5"
                            style="padding-top:12px;padding-bottom: 12px;flex:1;font-size: 14px;">
                            <span>{{isMonthly ? feature.m_FREE == '-1'?'Unlimited':feature.m_FREE :
                                feature.a_FREE == '-1' ? 'Unlimited' : feature.a_FREE}}</span>
                            <span>{{isMonthly ? feature.m_FREE_NOTE : feature.a_FREE_NOTE}}</span>
                        </div>
                    </ng-container>
                    <ng-template #checkmarkFree>
                        <div style="flex:1"
                            class="col-md-2 bg-white cl-border-x-[1px] cl-flex cl-items-center cl-justify-center cl-py-4 cl-flex-col gap-5">

                            <div class="cl-rounded-full cl-flex cl-items-center cl-justify-center"
                                style="width: 22px; height: 22px;">

                                <!-- Pick correct field based on isMonthly -->
                                <ng-container
                                    *ngIf="(isMonthly ? feature.m_FREE : feature.a_FREE) === 'true'; else crossIcon">
                                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <rect width="22" height="22" rx="11" fill="#2c77e880"></rect>
                                        <path
                                            d="M15.9763 7.89755L8.97223 14.9286L5.76202 11.706L6.585 10.8799L8.97223 13.2704L15.1533 7.07141L15.9763 7.89755Z"
                                            fill="black"></path>
                                    </svg>
                                </ng-container>

                                <ng-template #crossIcon>
                                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <rect width="22" height="22" rx="11" fill="#F8D7DA" />
                                        <path
                                            d="M14.1213 7.87868L11 11M11 11L7.87868 14.1213M11 11L14.1213 14.1213M11 11L7.87868 7.87868"
                                            stroke="red" stroke-width="2" stroke-linecap="round" />
                                    </svg>
                                </ng-template>

                            </div>

                            <div class="body-medium text-center" style="font-size: 14px;">
                                {{ isMonthly ? feature.m_FREE_NOTE : feature.a_FREE_NOTE }}
                            </div>
                        </div>
                    </ng-template>
                    <ng-container *ngIf="isNumericValue(feature.a_ESSENTIAL); else checkmarkESSENTIAL">
                        <!-- Numeric value → Line bar div -->
                        <div class="col-md-2 bg-white cl-border-x-[1px] body-medium cl-text-center cl-text-g0-primary cl-flex cl-content-center cl-py-5 cl-flex-col gap-5"
                            style="padding-top:12px;padding-bottom: 12px;flex:1;font-size: 14px;">
                            <span>{{isMonthly ? feature.m_ESSENTIAL == '-1'?'Unlimited':feature.m_ESSENTIAL :
                                feature.a_ESSENTIAL == '-1' ? 'Unlimited' : feature.a_ESSENTIAL}}</span>
                            <span>{{isMonthly ? feature.m_ESSENTIAL_NOTE : feature.a_ESSENTIAL_NOTE}}</span>
                        </div>
                    </ng-container>
                    <ng-template #checkmarkESSENTIAL>
                        <div style="flex:1"
                            class="col-md-2 bg-white cl-border-x-[1px] cl-flex cl-items-center cl-justify-center cl-py-4 cl-flex-col gap-5">
                            <div class="cl-rounded-full cl-flex cl-items-center cl-justify-center"
                                style="width: 22px; height: 22px;">

                                <!-- Pick correct field based on isMonthly -->
                                <ng-container
                                    *ngIf="(isMonthly ? feature.m_ESSENTIAL : feature.a_ESSENTIAL) === 'true'; else crossIcon">
                                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <rect width="22" height="22" rx="11" fill="#2c77e880"></rect>
                                        <path
                                            d="M15.9763 7.89755L8.97223 14.9286L5.76202 11.706L6.585 10.8799L8.97223 13.2704L15.1533 7.07141L15.9763 7.89755Z"
                                            fill="black"></path>
                                    </svg>
                                </ng-container>

                                <ng-template #crossIcon>
                                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <rect width="22" height="22" rx="11" fill="#F8D7DA" />
                                        <path
                                            d="M14.1213 7.87868L11 11M11 11L7.87868 14.1213M11 11L14.1213 14.1213M11 11L7.87868 7.87868"
                                            stroke="red" stroke-width="2" stroke-linecap="round" />
                                    </svg>
                                </ng-template>

                            </div>

                            <div class="body-medium text-center" style="font-size: 14px;">
                                {{ isMonthly ? feature.m_ESSENTIAL_NOTE : feature.a_ESSENTIAL_NOTE }}
                            </div>
                        </div>
                    </ng-template>
                    <ng-container *ngIf="isNumericValue(feature.a_PREMIUM); else checkmarkPREMIUM">
                        <!-- Numeric value → Line bar div -->
                        <div style="padding-top:12px;padding-bottom: 12px;flex:1;font-size: 14px;"
                            class="col-md-2 bg-white cl-border-x-[1px] body-medium cl-text-center cl-text-g0-primary cl-flex cl-content-center cl-py-5 most-popular cl-flex-col gap-5">
                            <span>{{isMonthly ? feature.m_PREMIUM == '-1'?'Unlimited':feature.m_PREMIUM :
                                feature.a_PREMIUM == '-1' ? 'Unlimited' : feature.a_PREMIUM}}</span>
                            <span>{{isMonthly ? feature.m_PREMIUM_NOTE : feature.m_PREMIUM_NOTE}}</span>
                        </div>
                    </ng-container>
                    <ng-template #checkmarkPREMIUM>
                        <div style="flex:1"
                            class="col-md-2 bg-white cl-border-x-[1px] cl-flex cl-items-center cl-justify-center cl-py-4 cl-flex-col gap-5 most-popular">
                            <div class="cl-rounded-full cl-flex cl-items-center cl-justify-center"
                                style="width: 22px; height: 22px;">
                                <!-- Pick correct field based on isMonthly -->
                                <ng-container
                                    *ngIf="(isMonthly ? feature.m_PREMIUM : feature.a_PREMIUM) === 'true'; else crossIcon">
                                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <rect width="22" height="22" rx="11" fill="#2c77e880"></rect>
                                        <path
                                            d="M15.9763 7.89755L8.97223 14.9286L5.76202 11.706L6.585 10.8799L8.97223 13.2704L15.1533 7.07141L15.9763 7.89755Z"
                                            fill="black"></path>
                                    </svg>
                                </ng-container>

                                <ng-template #crossIcon>
                                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <rect width="22" height="22" rx="11" fill="#F8D7DA" />
                                        <path
                                            d="M14.1213 7.87868L11 11M11 11L7.87868 14.1213M11 11L14.1213 14.1213M11 11L7.87868 7.87868"
                                            stroke="red" stroke-width="2" stroke-linecap="round" />
                                    </svg>
                                </ng-template>
                            </div>
                            <div class="body-medium text-center" style="font-size: 14px;">
                                {{isMonthly ? feature.m_PREMIUM_NOTE : feature.a_PREMIUM_NOTE}}
                            </div>
                        </div>
                    </ng-template>
                    <ng-container *ngIf="isNumericValue(feature.a_PROFESSIONAL); else checkmarkPROFESSIONAL">
                        <!-- Numeric value → Line bar div -->
                        <div style="padding-top:12px;padding-bottom: 12px;flex:1;font-size: 14px;"
                            class="col-md-2 bg-white cl-border-x-[1px] body-medium cl-text-center cl-text-g0-primary cl-flex cl-content-center cl-py-5 cl-flex-col gap-5">
                            <span>{{isMonthly ? feature.m_PROFESSIONAL == '-1'?'Unlimited':feature.m_PROFESSIONAL :
                                feature.a_PROFESSIONAL == '-1' ? 'Unlimited' : feature.a_PROFESSIONAL}}</span>
                            <span>{{isMonthly ? feature.m_PROFESSIONAL_NOTE : feature.a_PROFESSIONAL_NOTE}}</span>
                        </div>
                    </ng-container>
                    <ng-template #checkmarkPROFESSIONAL>
                        <div style="flex:1"
                            class="col-md-2 bg-white cl-border-x-[1px] cl-flex cl-items-center cl-justify-center cl-py-4 cl-flex-col gap-5">
                            <div class="cl-rounded-full cl-flex cl-items-center cl-justify-center"
                                style="width: 22px; height: 22px;">
                                <!-- Pick correct field based on isMonthly -->
                                <ng-container
                                    *ngIf="(isMonthly ? feature.m_PROFESSIONAL : feature.a_PROFESSIONAL) === 'true'; else crossIcon">
                                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <rect width="22" height="22" rx="11" fill="#2c77e880"></rect>
                                        <path
                                            d="M15.9763 7.89755L8.97223 14.9286L5.76202 11.706L6.585 10.8799L8.97223 13.2704L15.1533 7.07141L15.9763 7.89755Z"
                                            fill="black"></path>
                                    </svg>
                                </ng-container>

                                <ng-template #crossIcon>
                                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <rect width="22" height="22" rx="11" fill="#F8D7DA" />
                                        <path
                                            d="M14.1213 7.87868L11 11M11 11L7.87868 14.1213M11 11L14.1213 14.1213M11 11L7.87868 7.87868"
                                            stroke="red" stroke-width="2" stroke-linecap="round" />
                                    </svg>
                                </ng-template>
                            </div>
                            <div class="body-medium text-center" style="font-size: 14px;">
                                {{isMonthly ? feature.m_PROFESSIONAL_NOTE : feature.a_PROFESSIONAL_NOTE}}
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>
            <div class="cl-flex cl-flex-col">
                <div class="col-md-12 cl-flex md:cl-gap-2 p-0">
                    <div class="col-md-4 cl-body-medium cl-content-center" style="flex:2">
                        <div class="title-medium" style="padding-top: 30px;padding-bottom: 12px;">
                        </div>
                    </div>
                    <div style="flex:1"
                        class="col-md-2 bg-white cl-border-x-[1px] body-medium cl-text-center cl-text-g0-primary  cl-content-center cl-py-5 cl-rounded-b-[16px] cl-border-bottom cl-shadow-depth2x">
                        <div class="cl-rounded-full cl-flex cl-items-center cl-justify-center"
                            style="width: 22px; height: 22px;">
                        </div>
                    </div>
                    <div style="flex:1"
                        class="col-md-2 bg-white cl-border-x-[1px] body-medium cl-text-center cl-text-g0-primary  cl-content-center cl-py-5 cl-rounded-b-[16px] cl-border-bottom cl-shadow-depth2x">
                        <div class="cl-rounded-full cl-flex cl-items-center cl-justify-center"
                            style="width: 22px; height: 22px;">
                        </div>
                    </div>
                    <div style="flex:1"
                        class="col-md-2 bg-white cl-border-x-[1px] body-medium cl-text-center cl-text-g0-primary  cl-content-center cl-py-5 most-popular bottom-border-green cl-rounded-b-[16px] cl-border-bottom cl-shadow-depth2x">
                        <div class="cl-rounded-full cl-flex cl-items-center cl-justify-center"
                            style="width: 22px; height: 22px;">
                        </div>
                    </div>
                    <div style="flex:1"
                        class="col-md-2 bg-white cl-border-x-[1px] body-medium cl-text-center cl-text-g0-primary  cl-content-center cl-py-5 cl-rounded-b-[16px] cl-border-bottom cl-shadow-depth2x">
                        <div class="cl-rounded-full cl-flex cl-items-center cl-justify-center"
                            style="width: 22px; height: 22px;">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Fixed clone -->
        <div class="fixed-header" [ngStyle]="fixedStyle" *ngIf="showFixedHeader">
            <div class="col-md-12 cl-flex md:cl-gap-2 p-0">
                <div class="col-md-4 cl-flex cl-flex-col cl-pt-6 cl-px-2 lg:cl-pt-5"
                    [ngStyle]="{'background-color': isFromHomePgae ? '#EEF2F5' : '#F2F3F8'}"
                    style="flex-direction: column;justify-content: space-between;flex:2;;border-bottom: 1px solid rgb(220 220 220 / 1);">
                    <div class="title-large text-center">Compare Plans</div>
                    <div class="title-medium cl-pb-3 cl-pt-10 cl-border-b-[1px] cl-border-b-gray-100 md:cl-w-[192px] lg:cl-w-[242px] hidden"
                        style="padding-bottom: 37px;padding-left: 10px;">GENERAL FEATURES</div>
                </div>
                <ng-container *ngIf="!isMonthly">
                    <div *ngFor="let plan of annualPlanOutput"
                        class="col-md-2 bg-white cl-border-g0-gray-100 cl-border-b-0 lg:cl-pt-5"
                        [ngClass]="{'most-popular bb-unset': plan.heading.toLowerCase()== 'premium'}"
                        style="display: flex;flex-direction: column;gap: 5px;flex:1;border-color: rgb(220 220 220 / 1);">
                        <div class="cl-flex cl-items-center">
                            <svg *ngIf="plan.heading.toLowerCase()== 'premium'" fill="none" viewBox="0 0 22 22"
                                class="cl-mr-2" width="22" height="22" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M18.5625 4.125C17.4231 4.125 16.5 5.04883 16.5 6.1875C16.5 6.47625 16.5605 6.75005 16.6672 6.99995L13.75 8.25L11.3095 3.85773C11.9419 3.5047 12.375 2.83731 12.375 2.0625C12.375 0.923828 11.4519 0 10.3125 0C9.17314 0 8.25 0.923828 8.25 2.0625C8.25 2.83731 8.68313 3.5047 9.31545 3.85773L6.875 8.25L3.95777 6.99995C4.0645 6.75005 4.125 6.47625 4.125 6.1875C4.125 5.04883 3.20186 4.125 2.0625 4.125C0.923141 4.125 0 5.04883 0 6.1875C0 7.32617 0.923141 8.25 2.0625 8.25C2.22234 8.25 2.37566 8.22714 2.5257 8.19363L4.125 15.125V16.5C4.125 17.26 4.74066 17.875 5.5 17.875H15.125C15.8843 17.875 16.5 17.26 16.5 16.5V15.125L18.1 8.19363C18.249 8.22852 18.4027 8.25 18.5625 8.25C19.7019 8.25 20.625 7.32617 20.625 6.1875C20.625 5.04883 19.7019 4.125 18.5625 4.125ZM10.3125 1.375C10.6918 1.375 11 1.68386 11 2.0625C11 2.44114 10.6918 2.75 10.3125 2.75C9.93317 2.75 9.625 2.44114 9.625 2.0625C9.625 1.68386 9.93317 1.375 10.3125 1.375ZM1.375 6.1875C1.375 5.80886 1.68317 5.5 2.0625 5.5C2.44183 5.5 2.75 5.80886 2.75 6.1875C2.75 6.56614 2.44183 6.875 2.0625 6.875C1.68317 6.875 1.375 6.56614 1.375 6.1875ZM15.125 16.5H5.5V15.125H15.125V16.5ZM15.4057 13.75H5.21933L4.01156 8.51864L6.33325 9.51362C6.50908 9.58873 6.69298 9.625 6.87431 9.625C7.36037 9.625 7.8277 9.36719 8.07675 8.91739L10.3125 4.89448L12.5483 8.91739C12.7973 9.36719 13.2646 9.625 13.7507 9.625C13.932 9.625 14.1159 9.58873 14.2917 9.51362L16.6134 8.51864L15.4057 13.75ZM18.5625 6.875C18.1832 6.875 17.875 6.56614 17.875 6.1875C17.875 5.80886 18.1832 5.5 18.5625 5.5C18.9418 5.5 19.25 5.80886 19.25 6.1875C19.25 6.56614 18.9418 6.875 18.5625 6.875Z"
                                    fill="#2c77e8"></path>
                            </svg>
                            <div class="title-medium text-uppercase cl-text-g0-primary">
                                {{plan.heading}}
                            </div>
                        </div>
                        <div class="cl-text-[#777] caption cl-mb-6" style="min-height: 58.5px;">{{plan.subHeading}}
                        </div>
                        <ng-container *ngTemplateOutlet="planCtaButtons; context: { plan: plan, compact: isBetweenWidth, accountLabel: 'Create Account' }"></ng-container>
                        <hr class="cl-mt-6 mb-0" style="margin-left: -15px;margin-right: -15px;">
                    </div>
                </ng-container>
                <ng-container *ngIf="isMonthly">
                    <div *ngFor="let plan of monthlyPlanOutput"
                        class="col-md-2 bg-white cl-border-g0-gray-100 cl-border-b-0 lg:cl-pt-5"
                        [ngClass]="{'most-popular bb-unset': plan.heading.toLowerCase()== 'premium'}"
                        style="display: flex;flex-direction: column;gap: 5px;flex:1;border-color: rgb(220 220 220 / 1);">
                        <div class="cl-flex cl-items-center">
                            <svg *ngIf="plan.heading.toLowerCase()== 'premium'" fill="none" viewBox="0 0 22 22"
                                class="cl-mr-2" width="22" height="22" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M18.5625 4.125C17.4231 4.125 16.5 5.04883 16.5 6.1875C16.5 6.47625 16.5605 6.75005 16.6672 6.99995L13.75 8.25L11.3095 3.85773C11.9419 3.5047 12.375 2.83731 12.375 2.0625C12.375 0.923828 11.4519 0 10.3125 0C9.17314 0 8.25 0.923828 8.25 2.0625C8.25 2.83731 8.68313 3.5047 9.31545 3.85773L6.875 8.25L3.95777 6.99995C4.0645 6.75005 4.125 6.47625 4.125 6.1875C4.125 5.04883 3.20186 4.125 2.0625 4.125C0.923141 4.125 0 5.04883 0 6.1875C0 7.32617 0.923141 8.25 2.0625 8.25C2.22234 8.25 2.37566 8.22714 2.5257 8.19363L4.125 15.125V16.5C4.125 17.26 4.74066 17.875 5.5 17.875H15.125C15.8843 17.875 16.5 17.26 16.5 16.5V15.125L18.1 8.19363C18.249 8.22852 18.4027 8.25 18.5625 8.25C19.7019 8.25 20.625 7.32617 20.625 6.1875C20.625 5.04883 19.7019 4.125 18.5625 4.125ZM10.3125 1.375C10.6918 1.375 11 1.68386 11 2.0625C11 2.44114 10.6918 2.75 10.3125 2.75C9.93317 2.75 9.625 2.44114 9.625 2.0625C9.625 1.68386 9.93317 1.375 10.3125 1.375ZM1.375 6.1875C1.375 5.80886 1.68317 5.5 2.0625 5.5C2.44183 5.5 2.75 5.80886 2.75 6.1875C2.75 6.56614 2.44183 6.875 2.0625 6.875C1.68317 6.875 1.375 6.56614 1.375 6.1875ZM15.125 16.5H5.5V15.125H15.125V16.5ZM15.4057 13.75H5.21933L4.01156 8.51864L6.33325 9.51362C6.50908 9.58873 6.69298 9.625 6.87431 9.625C7.36037 9.625 7.8277 9.36719 8.07675 8.91739L10.3125 4.89448L12.5483 8.91739C12.7973 9.36719 13.2646 9.625 13.7507 9.625C13.932 9.625 14.1159 9.58873 14.2917 9.51362L16.6134 8.51864L15.4057 13.75ZM18.5625 6.875C18.1832 6.875 17.875 6.56614 17.875 6.1875C17.875 5.80886 18.1832 5.5 18.5625 5.5C18.9418 5.5 19.25 5.80886 19.25 6.1875C19.25 6.56614 18.9418 6.875 18.5625 6.875Z"
                                    fill="#2c77e8"></path>
                            </svg>
                            <div class="title-medium text-uppercase cl-text-g0-primary">
                                {{plan.heading}}
                            </div>
                        </div>
                        <div class="cl-text-[#777] caption cl-mb-6" style="min-height: 58.5px;">{{plan.subHeading}}
                        </div>
                        <ng-container *ngTemplateOutlet="planCtaButtons; context: { plan: plan, compact: isBetweenWidth, accountLabel: 'Create Account' }"></ng-container>
                        <hr class="cl-mt-6 mb-0" style="margin-left: -15px;margin-right: -15px;">
                    </div>
                </ng-container>
            </div>
        </div>
        <div #firstColumnMobile [ngStyle]="fixedStyleMobile" *ngIf="showFixedHeaderMobile">
            <div class="compare-plan  bg-white" *ngIf="!isMonthly"
                style="display: flex; flex-wrap: wrap; height: 100%;">
                <ng-container *ngFor="let plan of annualPlanOutput">
                    <div *ngIf="plan.heading.toLowerCase() !== 'free'" class="col-4 bg-white lg:cl-pt-5"
                        style="display: flex;flex-direction: column;gap: 5px;flex:1;  height: auto;">
                        <div class="cl-flex cl-items-center">
                            <div class="title-medium text-uppercase cl-text-g0-primary">
                                {{plan.heading}}
                            </div>
                        </div>
                        <div class="cl-text-[#777] caption cl-mb-6" style="min-height: auto;flex-grow: 1">
                            {{plan.subHeading}}
                        </div>
                        <ng-container *ngTemplateOutlet="planCtaButtons; context: { plan: plan, compact: true, accountLabel: 'Create Account' }"></ng-container>
                        <!-- <hr class="cl-mt-6 mb-0" style="margin-left: -15px;margin-right: -15px;"> -->
                    </div>
                </ng-container>
            </div>
            <div class="compare-plan  bg-white" *ngIf="isMonthly"
                style=" display: flex; flex-wrap: wrap; height: 100%;">
                <ng-container *ngFor="let plan of monthlyPlanOutput">
                    <div *ngIf="plan.heading.toLowerCase() !== 'free'" class="col-4 bg-white lg:cl-pt-5"
                        style="display: flex;flex-direction: column;gap: 5px;flex:1; height: auto;">
                        <div class="cl-flex cl-items-center">
                            <div class="title-medium text-uppercase cl-text-g0-primary">
                                {{plan.heading}}
                            </div>
                        </div>
                        <div class="cl-text-[#777] caption cl-mb-6" style="min-height: auto;flex-grow: 1">
                            {{plan.subHeading}}
                        </div>
                        <ng-container *ngTemplateOutlet="planCtaButtons; context: { plan: plan, compact: true, accountLabel: 'Create Account' }"></ng-container>
                        <!-- <hr class="cl-mt-6 mb-0" style="margin-left: -15px;margin-right: -15px;"> -->
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
<div #compareSectionMobile class="container compare-plan-container mt-5 pb-5"
    *ngIf="annualPlanOutput && annualPlanOutput.length > 0 && monthlyPlanOutput && monthlyPlanOutput.length > 0">
    <div #firstColumnMobile>
        <div class="compare-plan  bg-white" *ngIf="!isMonthly" style="display: flex; flex-wrap: wrap; height: 100%;">
            <ng-container *ngFor="let plan of annualPlanOutput">
                <div *ngIf="plan.heading.toLowerCase() !== 'free'" class="col-4 bg-white lg:cl-pt-5"
                    style="display: flex;flex-direction: column;gap: 5px;flex:1;  height: auto;">
                    <div class="cl-flex cl-items-center">
                        <div class="title-medium text-uppercase cl-text-g0-primary">
                            {{plan.heading}}
                        </div>
                    </div>
                    <div class="cl-text-[#777] caption cl-mb-6" style="min-height: auto;flex-grow: 1;">
                        {{plan.subHeading}}
                    </div>
                    <ng-container *ngTemplateOutlet="planCtaButtons; context: { plan: plan, compact: true, accountLabel: 'Create Account' }"></ng-container>
                    <!-- <hr class="cl-mt-6 mb-0" style="margin-left: -15px;margin-right: -15px;"> -->
                </div>
            </ng-container>
        </div>
        <div class="compare-plan  bg-white" *ngIf="isMonthly" style=" display: flex; flex-wrap: wrap; height: 100%;">
            <ng-container *ngFor="let plan of monthlyPlanOutput">
                <div *ngIf="plan.heading.toLowerCase() !== 'free'" class="col-4 bg-white lg:cl-pt-5"
                    style="display: flex;flex-direction: column;gap: 5px;flex:1; height: auto;">
                    <div class="cl-flex cl-items-center">
                        <div class="title-medium text-uppercase cl-text-g0-primary">
                            {{plan.heading}}
                        </div>
                    </div>
                    <div class="cl-text-[#777] caption cl-mb-6" style="min-height: auto;flex-grow: 1">
                        {{plan.subHeading}}
                    </div>
                    <ng-container *ngTemplateOutlet="planCtaButtons; context: { plan: plan, compact: true, accountLabel: 'Create Account' }"></ng-container>
                    <!-- <hr class="cl-mt-6 mb-0" style="margin-left: -15px;margin-right: -15px;"> -->
                </div>
            </ng-container>
        </div>
        <div class="accordion" *ngIf="groupedComparePlans && groupedComparePlans.length > 0">
            <div class="accordion-item" *ngFor="let section of sections; let i = index">

                <div class="accordion-header" (click)="toggleSection(i)">
                    <span style="font-size: 12px; color: #1a1a1a !important;">{{ section.title }}</span>
                    <span class="icon">{{ section.expanded ? '−' : '+' }}</span>
                </div>

                <div class="accordion-content" *ngIf="section.expanded">
                    <table class="feature-table">
                        <ng-container *ngFor="let block of section.content">
                            <tr>
                                <td colspan="3" class="cl-body-medium cl-content-center"
                                    style="line-height: 20px; font-size: 12px; font-weight: 600; text-align: center; padding: 10px 0 0 0; color: #1a1a1a !important;">
                                    {{ block.heading }}
                                </td>
                            </tr>
                            <tr class="c-border-bottom">
                                <td *ngFor="let cell of block.data" class="feature-cell">
                                    <div class="bg-white body-medium cl-text-center cl-text-g0-primary  cl-content-center cl-py-5 pt-0"
                                        style="flex:1;font-size: 12px;" [innerHTML]="cell[0]">
                                    </div>
                                </td>
                            </tr>
                        </ng-container>
                        <ng-container *ngFor="let feature of groupedComparePlans[0].features;">
                            <tr *ngIf="section.features">
                                <td colspan="3" class="cl-body-medium cl-content-center"
                                    style="line-height: 20px; font-size: 12px; font-weight: 600; text-align: center; padding: 10px 0 6px; color: #1a1a1a !important;">
                                    {{feature.featureType}}
                                </td>
                            </tr>
                            <tr class="c-border-bottom" *ngIf="section.features">
                                <ng-container *ngIf="isNumericValue(feature.a_ESSENTIAL); else checkmarkESSENTIAL">
                                    <!-- Numeric value → Line bar div -->
                                    <td>
                                        <div class="bg-white body-medium cl-text-center cl-text-g0-primary cl-flex cl-content-center cl-flex-col gap-5"
                                            style="padding-top:12px;padding-bottom: 10px;flex:1;font-size: 12px;">
                                            <span>{{isMonthly ? feature.m_ESSENTIAL ==
                                                '-1'?'Unlimited':feature.m_ESSENTIAL
                                                :
                                                feature.a_ESSENTIAL == '-1' ? 'Unlimited' : feature.a_ESSENTIAL}}</span>
                                            <span>{{isMonthly ? feature.m_ESSENTIAL_NOTE :
                                                feature.a_ESSENTIAL_NOTE}}</span>
                                        </div>
                                    </td>
                                </ng-container>
                                <ng-template #checkmarkESSENTIAL>
                                    <td>
                                        <div style="flex:1;"
                                            class="bg-white cl-flex cl-items-center cl-justify-center cl-flex-col gap-5">
                                            <div class="cl-rounded-full cl-flex cl-items-center cl-justify-center"
                                                style="width: 100%; height: 100%;">

                                                <!-- Pick correct field based on isMonthly -->
                                                <ng-container
                                                    *ngIf="(isMonthly ? feature.m_ESSENTIAL : feature.a_ESSENTIAL) === 'true'; else crossIcon">
                                                    <svg width="25" height="25" viewBox="0 0 22 22" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <rect width="22" height="22" rx="11" fill="#2c77e880"></rect>
                                                        <path
                                                            d="M15.9763 7.89755L8.97223 14.9286L5.76202 11.706L6.585 10.8799L8.97223 13.2704L15.1533 7.07141L15.9763 7.89755Z"
                                                            fill="black"></path>
                                                    </svg>
                                                </ng-container>

                                                <ng-template #crossIcon>
                                                    <svg width="25" height="25" viewBox="0 0 22 22" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <rect width="22" height="22" rx="11" fill="#F8D7DA" />
                                                        <path
                                                            d="M14.1213 7.87868L11 11M11 11L7.87868 14.1213M11 11L14.1213 14.1213M11 11L7.87868 7.87868"
                                                            stroke="red" stroke-width="2" stroke-linecap="round" />
                                                    </svg>
                                                </ng-template>

                                            </div>

                                            <div class="body-medium text-center"
                                                style="font-size: 12px; line-height: 14px;">
                                                {{ isMonthly ? feature.m_ESSENTIAL_NOTE : feature.a_ESSENTIAL_NOTE }}
                                            </div>
                                        </div>
                                    </td>
                                </ng-template>
                                <ng-container *ngIf="isNumericValue(feature.a_PREMIUM); else checkmarkPREMIUM">
                                    <!-- Numeric value → Line bar div -->
                                    <td>
                                        <div style="padding-top:12px;padding-bottom: 12px;flex:1;font-size: 12px;"
                                            class="bg-white body-medium cl-text-center cl-text-g0-primary cl-flex cl-content-center cl-flex-col gap-5">
                                            <span>{{isMonthly ? feature.m_PREMIUM == '-1'?'Unlimited':feature.m_PREMIUM
                                                :
                                                feature.a_PREMIUM == '-1' ? 'Unlimited' : feature.a_PREMIUM}}</span>
                                            <span>{{isMonthly ? feature.m_PREMIUM_NOTE : feature.m_PREMIUM_NOTE}}</span>
                                        </div>
                                    </td>
                                </ng-container>
                                <ng-template #checkmarkPREMIUM>
                                    <td>
                                        <div style="flex:1;"
                                            class="bg-white cl-flex cl-items-center cl-justify-center cl-flex-col gap-5">
                                            <div class="cl-rounded-full cl-flex cl-items-center cl-justify-center"
                                                style="width: 100%; height: 100%;">
                                                <!-- Pick correct field based on isMonthly -->
                                                <ng-container
                                                    *ngIf="(isMonthly ? feature.m_PREMIUM : feature.a_PREMIUM) === 'true'; else crossIcon">
                                                    <svg width="25" height="25" viewBox="0 0 22 22" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <rect width="22" height="22" rx="11" fill="#2c77e880"></rect>
                                                        <path
                                                            d="M15.9763 7.89755L8.97223 14.9286L5.76202 11.706L6.585 10.8799L8.97223 13.2704L15.1533 7.07141L15.9763 7.89755Z"
                                                            fill="black"></path>
                                                    </svg>
                                                </ng-container>

                                                <ng-template #crossIcon>
                                                    <svg width="25" height="25" viewBox="0 0 22 22" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <rect width="22" height="22" rx="11" fill="#F8D7DA" />
                                                        <path
                                                            d="M14.1213 7.87868L11 11M11 11L7.87868 14.1213M11 11L14.1213 14.1213M11 11L7.87868 7.87868"
                                                            stroke="red" stroke-width="2" stroke-linecap="round" />
                                                    </svg>
                                                </ng-template>
                                            </div>
                                            <div class="body-medium text-center"
                                                style="font-size: 12px; line-height: 14px;">
                                                {{isMonthly ? feature.m_PREMIUM_NOTE : feature.a_PREMIUM_NOTE}}
                                            </div>
                                        </div>
                                    </td>
                                </ng-template>
                                <ng-container
                                    *ngIf="isNumericValue(feature.a_PROFESSIONAL); else checkmarkPROFESSIONAL">
                                    <!-- Numeric value → Line bar div -->
                                    <td>
                                        <div style="padding-top:12px;padding-bottom: 12px;flex:1;font-size: 12px;"
                                            class="bg-white body-medium cl-text-center cl-text-g0-primary cl-flex cl-content-center cl-flex-col gap-5">
                                            <span>{{isMonthly ? feature.m_PROFESSIONAL ==
                                                '-1'?'Unlimited':feature.m_PROFESSIONAL :
                                                feature.a_PROFESSIONAL == '-1' ? 'Unlimited' :
                                                feature.a_PROFESSIONAL}}</span>
                                            <span>{{isMonthly ? feature.m_PROFESSIONAL_NOTE :
                                                feature.a_PROFESSIONAL_NOTE}}</span>
                                        </div>
                                    </td>
                                </ng-container>
                                <ng-template #checkmarkPROFESSIONAL>
                                    <td>
                                        <div style="flex:1;"
                                            class="bg-white cl-flex cl-items-center cl-justify-center cl-flex-col gap-5">
                                            <div class="cl-rounded-full cl-flex cl-items-center cl-justify-center"
                                                style="width: 100%; height: 100%;">
                                                <!-- Pick correct field based on isMonthly -->
                                                <ng-container
                                                    *ngIf="(isMonthly ? feature.m_PROFESSIONAL : feature.a_PROFESSIONAL) === 'true'; else crossIcon">
                                                    <svg width="25" height="25" viewBox="0 0 22 22" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <rect width="22" height="22" rx="11" fill="#2c77e880"></rect>
                                                        <path
                                                            d="M15.9763 7.89755L8.97223 14.9286L5.76202 11.706L6.585 10.8799L8.97223 13.2704L15.1533 7.07141L15.9763 7.89755Z"
                                                            fill="black"></path>
                                                    </svg>
                                                </ng-container>

                                                <ng-template #crossIcon>
                                                    <svg width="25" height="25" viewBox="0 0 22 22" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <rect width="22" height="22" rx="11" fill="#F8D7DA" />
                                                        <path
                                                            d="M14.1213 7.87868L11 11M11 11L7.87868 14.1213M11 11L14.1213 14.1213M11 11L7.87868 7.87868"
                                                            stroke="red" stroke-width="2" stroke-linecap="round" />
                                                    </svg>
                                                </ng-template>
                                            </div>
                                            <div class="body-medium text-center"
                                                style="font-size: 12px; line-height: 14px;">
                                                {{isMonthly ? feature.m_PROFESSIONAL_NOTE :
                                                feature.a_PROFESSIONAL_NOTE}}
                                            </div>
                                        </div>
                                    </td>
                                </ng-template>
                            </tr>
                        </ng-container>
                    </table>
                </div>

            </div>
        </div>
        <div class="accordion">
            <div class="accordion-item" *ngFor="let group of groupedComparePlans; let i = index">
                <div *ngIf="getCalculationTypeName(group.calculationTypeId)" class="accordion-header"
                    (click)="toggleSectionIndex(i)">
                    <span style="font-size: 12px; color: #1a1a1a !important;">{{
                        getCalculationTypeName(group.calculationTypeId) }}</span>
                    <span class="icon">{{ expanded[i] ? '−' : '+' }}</span>
                </div>

                <div class="accordion-content" *ngIf="expanded[i]">
                    <table class="feature-table">
                        <ng-container *ngFor="let feature of group.features; let i = index">
                            <tr>
                                <td colspan="3" class="cl-body-medium cl-content-center"
                                    style="line-height: 20px; font-size: 12px; font-weight: 600; text-align: center; padding: 10px 0 6px; color: #1a1a1a !important;">
                                    {{feature.featureType}}
                                </td>
                            </tr>
                            <tr style="display: flex;" class="c-border-bottom">
                                <ng-container *ngIf="isNumericValue(feature.a_ESSENTIAL); else checkmarkESSENTIAL">
                                    <!-- Numeric value → Line bar div -->
                                    <td class="bg-white body-medium cl-text-center cl-text-g0-primary cl-flex cl-content-center cl-py-5 cl-flex-col gap-5"
                                        style="padding-top:12px;padding-bottom: 12px;flex:1;font-size: 12px;">
                                        <span>{{isMonthly ? feature.m_ESSENTIAL == '-1'?'Unlimited':feature.m_ESSENTIAL
                                            :
                                            feature.a_ESSENTIAL == '-1' ? 'Unlimited' : feature.a_ESSENTIAL}}</span>
                                        <span>{{isMonthly ? feature.m_ESSENTIAL_NOTE : feature.a_ESSENTIAL_NOTE}}</span>
                                    </td>
                                </ng-container>
                                <ng-template #checkmarkESSENTIAL>
                                    <td style="flex:1;"
                                        class="bg-white cl-flex cl-items-center cl-justify-center cl-py-4 cl-flex-col gap-5">
                                        <div class="cl-rounded-full cl-flex cl-items-center cl-justify-center"
                                            style="width: 100%; height: 100%;">

                                            <!-- Pick correct field based on isMonthly -->
                                            <ng-container
                                                *ngIf="(isMonthly ? feature.m_ESSENTIAL : feature.a_ESSENTIAL) === 'true'; else crossIcon">
                                                <svg width="25" height="25" viewBox="0 0 22 22" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <rect width="22" height="22" rx="11" fill="#2c77e880"></rect>
                                                    <path
                                                        d="M15.9763 7.89755L8.97223 14.9286L5.76202 11.706L6.585 10.8799L8.97223 13.2704L15.1533 7.07141L15.9763 7.89755Z"
                                                        fill="black"></path>
                                                </svg>
                                            </ng-container>

                                            <ng-template #crossIcon>
                                                <svg width="25" height="25" viewBox="0 0 22 22" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <rect width="22" height="22" rx="11" fill="#F8D7DA" />
                                                    <path
                                                        d="M14.1213 7.87868L11 11M11 11L7.87868 14.1213M11 11L14.1213 14.1213M11 11L7.87868 7.87868"
                                                        stroke="red" stroke-width="2" stroke-linecap="round" />
                                                </svg>
                                            </ng-template>

                                        </div>

                                        <div class="body-medium text-center"
                                            style="font-size: 12px; line-height: 14px;">
                                            {{ isMonthly ? feature.m_ESSENTIAL_NOTE : feature.a_ESSENTIAL_NOTE }}
                                        </div>
                                    </td>
                                </ng-template>
                                <ng-container *ngIf="isNumericValue(feature.a_PREMIUM); else checkmarkPREMIUM">
                                    <!-- Numeric value → Line bar div -->
                                    <td style="padding-top:12px;padding-bottom: 12px;flex:1;font-size: 12px;"
                                        class="bg-white body-medium cl-text-center cl-text-g0-primary cl-flex cl-content-center cl-py-5 cl-flex-col gap-5">
                                        <span>{{isMonthly ? feature.m_PREMIUM == '-1'?'Unlimited':feature.m_PREMIUM :
                                            feature.a_PREMIUM == '-1' ? 'Unlimited' : feature.a_PREMIUM}}</span>
                                        <span>{{isMonthly ? feature.m_PREMIUM_NOTE : feature.m_PREMIUM_NOTE}}</span>
                                    </td>
                                </ng-container>
                                <ng-template #checkmarkPREMIUM>
                                    <td style="flex:1;"
                                        class="bg-white cl-flex cl-items-center cl-justify-center cl-py-4 cl-flex-col gap-5">
                                        <div class="cl-rounded-full cl-flex cl-items-center cl-justify-center"
                                            style="width: 100%; height: 100%;">
                                            <!-- Pick correct field based on isMonthly -->
                                            <ng-container
                                                *ngIf="(isMonthly ? feature.m_PREMIUM : feature.a_PREMIUM) === 'true'; else crossIcon">
                                                <svg width="25" height="25" viewBox="0 0 22 22" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <rect width="22" height="22" rx="11" fill="#2c77e880"></rect>
                                                    <path
                                                        d="M15.9763 7.89755L8.97223 14.9286L5.76202 11.706L6.585 10.8799L8.97223 13.2704L15.1533 7.07141L15.9763 7.89755Z"
                                                        fill="black"></path>
                                                </svg>
                                            </ng-container>

                                            <ng-template #crossIcon>
                                                <svg width="25" height="25" viewBox="0 0 22 22" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <rect width="22" height="22" rx="11" fill="#F8D7DA" />
                                                    <path
                                                        d="M14.1213 7.87868L11 11M11 11L7.87868 14.1213M11 11L14.1213 14.1213M11 11L7.87868 7.87868"
                                                        stroke="red" stroke-width="2" stroke-linecap="round" />
                                                </svg>
                                            </ng-template>
                                        </div>
                                        <div class="body-medium text-center"
                                            style="font-size: 12px; line-height: 14px;">
                                            {{isMonthly ? feature.m_PREMIUM_NOTE : feature.a_PREMIUM_NOTE}}
                                        </div>
                                    </td>
                                </ng-template>
                                <ng-container
                                    *ngIf="isNumericValue(feature.a_PROFESSIONAL); else checkmarkPROFESSIONAL">
                                    <!-- Numeric value → Line bar div -->
                                    <td style="padding-top:12px;padding-bottom: 12px;flex:1;font-size: 12px;"
                                        class="bg-white body-medium cl-text-center cl-text-g0-primary cl-flex cl-content-center cl-py-5 cl-flex-col gap-5">
                                        <span>{{isMonthly ? feature.m_PROFESSIONAL ==
                                            '-1'?'Unlimited':feature.m_PROFESSIONAL :
                                            feature.a_PROFESSIONAL == '-1' ? 'Unlimited' :
                                            feature.a_PROFESSIONAL}}</span>
                                        <span>{{isMonthly ? feature.m_PROFESSIONAL_NOTE :
                                            feature.a_PROFESSIONAL_NOTE}}</span>
                                    </td>
                                </ng-container>
                                <ng-template #checkmarkPROFESSIONAL>
                                    <td style="flex:1;"
                                        class="bg-white cl-flex cl-items-center cl-justify-center cl-py-4 cl-flex-col gap-5">
                                        <div class="cl-rounded-full cl-flex cl-items-center cl-justify-center"
                                            style="width: 100%; height: 100%;">
                                            <!-- Pick correct field based on isMonthly -->
                                            <ng-container
                                                *ngIf="(isMonthly ? feature.m_PROFESSIONAL : feature.a_PROFESSIONAL) === 'true'; else crossIcon">
                                                <svg width="25" height="25" viewBox="0 0 22 22" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <rect width="22" height="22" rx="11" fill="#2c77e880"></rect>
                                                    <path
                                                        d="M15.9763 7.89755L8.97223 14.9286L5.76202 11.706L6.585 10.8799L8.97223 13.2704L15.1533 7.07141L15.9763 7.89755Z"
                                                        fill="black"></path>
                                                </svg>
                                            </ng-container>

                                            <ng-template #crossIcon>
                                                <svg width="25" height="25" viewBox="0 0 22 22" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <rect width="22" height="22" rx="11" fill="#F8D7DA" />
                                                    <path
                                                        d="M14.1213 7.87868L11 11M11 11L7.87868 14.1213M11 11L14.1213 14.1213M11 11L7.87868 7.87868"
                                                        stroke="red" stroke-width="2" stroke-linecap="round" />
                                                </svg>
                                            </ng-template>
                                        </div>
                                        <div class="body-medium text-center"
                                            style="font-size: 12px; line-height: 14px;">
                                            {{isMonthly ? feature.m_PROFESSIONAL_NOTE : feature.a_PROFESSIONAL_NOTE}}
                                        </div>
                                    </td>
                                </ng-template>
                            </tr>
                        </ng-container>
                    </table>
                </div>

            </div>
        </div>
    </div>
</div>

<ng-template #planCtaButtons let-plan="plan" let-compact="compact" let-accountLabel="accountLabel">
    <div class="cplp-pricing-ctas">
        <div class="cplp-plan-cta-stack" *ngIf="!isPlanCtaHidden(plan) && !isPlanCtaContainerHidden(plan)">
            <button *ngIf="showPlanStatusButton(plan)" type="button"
                class="btn w-100"
                [ngClass]="isCurrentPlanButtonDisabled(plan) ? 'btn-plan-status-current' : 'btn-outlined'"
                [disabled]="isCurrentPlanButtonDisabled(plan)"
                (click)="BuySubscription(plan, false)">{{ getPlanStatusLabel(plan, compact) }}</button>

            <button *ngIf="showTrialButton(plan)" type="button"
                class="btn btn-outlined w-100"
                [disabled]="btnDisabled"
                (click)="BuySubscription(plan, true)">{{ getTrialButtonLabel(compact) }}</button>

            <button *ngIf="showBuyButton(plan)" type="button"
                class="btn btn-filled w-100 m-0"
                [disabled]="btnDisabled"
                (click)="BuySubscription(plan, false)">{{ getBuyButtonLabel(compact) }}</button>

            <button *ngIf="showGuestPaidPlanButton(plan)" type="button"
                class="btn btn-outlined w-100"
                [disabled]="btnDisabled"
                (click)="BuySubscription(plan, false)">{{ getBuyButtonLabel(compact) }}</button>
        </div>

        <button *ngIf="showCreateAccountButton(plan)" type="button"
            class="btn btn-filled w-100 m-0"
            (click)="CreateAccount(plan)">{{ accountLabel || 'Create Account' }}</button>
    </div>
</ng-template>
</div>